const LOGIN_REDIRECT_KEY = 'redirectAfterLogin';
const LAST_LOGIN_KEY = 'lastSuccessfulLoginAt';
const LOGIN_REDIRECT_MAX_AGE_MS = 60 * 60 * 1000;

export const SESSION_EXPIRED_EVENT = 'auth:session-expired';

export function rememberLoginRedirect(path) {
  if (!path || path === '/login' || path.startsWith('/login?')) return;

  sessionStorage.setItem(LOGIN_REDIRECT_KEY, JSON.stringify({ path }));
}

export function consumeLoginRedirect() {
  const rawValue = sessionStorage.getItem(LOGIN_REDIRECT_KEY);
  sessionStorage.removeItem(LOGIN_REDIRECT_KEY);
  const previousLoginAt = Number(localStorage.getItem(LAST_LOGIN_KEY));
  localStorage.setItem(LAST_LOGIN_KEY, String(Date.now()));
  const wasRecentlyLoggedIn = Number.isFinite(previousLoginAt)
    && previousLoginAt > 0
    && Date.now() - previousLoginAt <= LOGIN_REDIRECT_MAX_AGE_MS;

  if (!rawValue) return '/dashboard';

  try {
    const redirect = JSON.parse(rawValue);
    const isInternalPath = typeof redirect.path === 'string'
      && redirect.path.startsWith('/')
      && !redirect.path.startsWith('//');

    if (!isInternalPath) return '/dashboard';

    // Scan-Deeplinks (QR-Codes für Kommen/Gehen) müssen auch beim ersten
    // Login auf einem neuen Gerät funktionieren.
    const isScanDeeplink = redirect.path.startsWith('/ma/scan');
    if (!wasRecentlyLoggedIn && !isScanDeeplink) return '/dashboard';

    return redirect.path;
  } catch {
    return '/dashboard';
  }
}